<template>
  <div>
    <div class="base-item">
      <img v-if="partnerLogo" style="border-radius: 16px;width: auto;height: 80px;margin-top: 24px;" :src="partnerLogo" alt="" />
      <div class="title">{{$t('crm_partner_examine_detail_religion.ji_chu_xin_xi')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.chang_suo_ming_cheng')}}</div>
          <div class="val">{{ data.partnerName }}</div>
        </div>
        <div class="col" v-if="data.partnerType==='CO'">
          <div class="key">{{$t('crm_partner_examine_detail_religion.ji_tuan_bian_hao')}}</div>
          <div class="val">{{data.partnerCode}}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.lei_xing')}}</div>
          <div class="val">{{ getDicValue('bas_org_type', data.partnerType) }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.lian_xi_dian_hua')}}</div>
          <div class="val">{{ data.telephone }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.you_xiang')}}</div>
          <div class="val">{{ data.email }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.wang_zhi')}}</div>
          <div class="val">{{ data.website }}</div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.tyshxydm')}}</div>
          <div class="val">{{ data.businessLicense }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.nsrsbhswdjbh')}}</div>
          <div class="val">{{ data.buyerNumber }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.zjhdcsfrdjzs')}}</div>
          <div class="val">
            <span class="detail" @click="visible = true">{{$t('Common.com_detail')}}</span>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.gui_mo')}}</div>
          <div class="val">{{getDicValue('crm_partner_scale',data.partnerScale)}}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.zhu_ce_zi_jin')}}</div>
          <div class="val">
            {{ data.currencyUnit }}{{ data.registeredCapital }}
          </div>
        </div>
        <div class="col" v-if="data.timeZoneDto&&timeZoneCountOverOne">
          <div class="key">
            {{ $t('crm_partner_examine_detail_religion.shi_qu') }}
          </div>
          <div class="val">
            {{ `(${data.timeZoneDto.utcZoneName})` }} {{ data.timeZoneDto.timeZoneRegion }}
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col long">
          <div class="key">{{$t('crm_partner_examine_detail_religion.di_zhi')}}</div>
          <div class="val">{{ [data.country, data.province, data.city].join("")
            }}{{ data.detailAddress }}</div>
        </div>
      </div>
    </div>
    <div class="base-item">
      <div class="title">{{$t('crm_partner_examine_detail_religion.fa_ren_xin_xi')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.fa_ren_xing_ming')}}</div>
          <div class="val">{{ data.legalPerson }}</div>
        </div>
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.frsfzh')}}</div>
          <div class="val">{{ data.legalPersonIdentity }}</div>
        </div>

        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.zheng_jian_zhao')}}</div>
          <div class="val">
            <span class="detail" @click="visible2 = true">{{$t('Common.com_detail')}}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="base-item">
      <div class="title">{{$t('crm_partner_examine_detail_religion.dgzhxx')}}</div>
      <div class="row">
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.dui_gong_zhang_hao')}}</div>
          <div class="val">{{ data.depositNumber }}</div>
        </div>
        <!-- <div class="col">
          <div class="key">{{$t('开户行','label_bankCode')}}</div>
          <div class="val">
            {{ data.bankName }}
          </div>
        </div> -->
        <div class="col">
          <div class="key">{{$t('crm_partner_examine_detail_religion.kai_hu_yin_hang')}}</div>
          <div class="val">{{ data.depositBank }}</div>
        </div>
      </div>
    </div>
    <img-detail-dialog
      :bizData="idPhotoData"
      :title="$t('crm_partner_examine_detail_religion.zheng_jian_zhao')"
      v-if="visible2"
      @close="visible2 = false"
    ></img-detail-dialog>
    <img-detail-dialog
      :bizData="licenseData"
      :title="$t('crm_partner_examine_detail_religion.zjhdcsfrdjzs')"
      v-if="visible"
      @close="visible = false"
    ></img-detail-dialog>
  </div>
</template>

<script>
// import apis from '@/utils/apis';

export default {
  components: {
  },
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    partnerId: String
  },
  computed: {
    // 证件照biz数据
    idPhotoData() {
      return [
        // 身份证人像面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.face'
        },
        // 身份证国徽面
        {
          bizId: this.partnerId,
          bizType: 'crm.id.reverse'
        }
      ];
    },
    // 营业执照biz数据
    licenseData() {
      return [
        {
          bizId: this.partnerId,
          bizType: 'crm.partner.license'
        }
      ];
    },
    timeZoneCountOverOne() {
      return this.$store.state.timeZoneCount > 1;
    },
  },
  watch: {
    'data.partnerOrgId': {
      immediate: true,
      handler(val) {
        if (val) {
          this.getLogo();
        }
      },
    },
  },
  data() {
    return {
      // 营业执照图片
      visible: false,
      // 证件照
      visible2: false,
      tableCode: 'company_admin_info',
      tableList: [],
      partnerLogo: null
    };
  },
  methods: {
    // 获取图片列表
    getLogo() {
      this.$getFileList({ bizId: this.data.partnerOrgId, bizType: 'crm.partner.logo' }).then((list) => {
        this.partnerLogo = list.length > 0 ? list[0].attachPath : null;
      });
    },
  },
  mounted() {
  }
};
</script>

<style lang="scss" scoped>

</style>
